import src from "IMAGE";
export default { src, width: 1331, height: 187, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mOYMnVqf3h4eLCzi4s9EFgDgbmPr6+bl7e3q4enpwsAtxoJ/81Oke4AAAAASUVORK5CYII="};
